import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/store";
import App from "./App";
import "./App.css";
// Create the root element using createRoot
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the App inside the root element
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
